/* eslint-disable react/prop-types, react/jsx-filename-extension */
import React from 'react';

import Date from '../../../common/date';
import Money from '../../../common/money';
import ImpersonateUser from '../../shared/ImpersonateUser';
import { t } from '../../../../../js/modules/infra/i18n';

export default () => [
  {
    Header: t('splits:columns.name'),
    accessor: 'name',
    id: 'name',
  },
  {
    Header: t('splits:columns.end_of_payout_period'),
    accessor: 'endOfPayout',
    id: 'endOfPayout',
    Cell: props => <Date date={props.value} timezone={props.original.timezone} />,
  },
  {
    Header: t('splits:columns.last_payout_date'),
    accessor: 'lastPayout',
    id: 'lastPayout',
    Cell: props => <Date date={props.value} timezone={props.original.timezone} />,
  },
  {
    Header: t('splits:columns.total'),
    accessor: 'total',
    id: 'total',
    Cell: props => <Money cents={props.value} />,
  },
  {
    Header: t('splits:columns.auto_transfers'),
    accessor: 'commissionSplitsAutoDeposit',
    id: 'commissionSplitsAutoDeposit',
    Cell: props => (props.value ? t('splits:columns.on') : t('splits:columns.off')),
  },
  {
    Header: t('splits:columns.actions'),
    accessor: 'userId',
    Cell: props => <ImpersonateUser id={props.value} />,
  }];
